import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ReportOrdersComponent } from './orders.component';

const routes: Routes = [{ path: '', component: ReportOrdersComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OrdersRoutingModule {}
